import contentfulGql from 'js/lib/contentfulGql';

export const AboutPageQuery = contentfulGql`#graphql
  query AboutPageQuery($preview: Boolean!, $slug: String!, $locale: String!) {
    generalAboutCollection(preview: $preview, locale: $locale, where: { slug: $slug }, limit: 1) {
      items {
        slug
        linksListCollection {
          items {
            route
            label
          }
        }
        title1
        title1ContentCollection {
          items {
            title
            description
          }
        }
        title2
        title2ContentCollection {
          items {
            title
            description
          }
        }
        title3
        title3ContentCollection {
          items {
            title
            description
          }
        }
        title4
        title4ContentCollection {
          items {
            title
            description
          }
        }
        title5
        title5ContentCollection {
          items {
            title
            description
          }
        }
        title6
        title6ContentCollection {
          items {
            title
            description
          }
        }
      }
    }
  }
`;

export default { AboutPageQuery };
